import { CustomerBooking } from '../../types';

const FirstOfficeHour = 7;
const LastOfficeHour = 19;

function asTime(hour: number) {
    return `${String(hour).padStart(2, '0')}:00:00`;
}

function endHour(booking: CustomerBooking) {
    let start = new Date(booking.start);
    let end = new Date(booking.end);
    if (end.toDateString() !== start.toDateString()) {
        return 24;
    }
    return end.getMinutes() > 0 ? end.getHours() + 1 : end.getHours();
}

export function visibleHours(bookings: CustomerBooking[]) {
    let earliestStart = Math.min(...bookings.map((b) => new Date(b.start).getHours()));
    let first = earliestStart <= FirstOfficeHour ? Math.max(0, earliestStart - 1) : FirstOfficeHour;
    let last = Math.max(LastOfficeHour, ...bookings.map(endHour));
    return { slotMinTime: asTime(first), slotMaxTime: asTime(last) };
}
